module.exports = __webpack_public_path__ + "static/Displacer_Beast-f18dd5a08849cc22b2b66ea77c8ed1a4.jpg";